import searchReducer from '../../presentation/containers/results/searchReducer';
import loaderReducer from '../../presentation/components/pageLoader/loaderReducer';
import browseSearchReducer from '../../presentation/containers/browse/searchReducer';
import commonReducer from './commonReducer';
import insightsReducer from '../../presentation/components/insights/insightsReducer';
// combineReducers will be handled internally by configureStore
export const rootReducer = () => ({
  search: searchReducer,
  browseSearch: browseSearchReducer,
  loader: loaderReducer,
  general: commonReducer,
  insightsfeedback: insightsReducer
});
